import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import LazyLoad from "react-lazyload";
import { connect } from "react-redux";
// import ReactGA from "react-ga";
// import { createBrowserHistory } from "history";

import firebase from "./firebase";
// import { initGA } from "./tracking";
import * as actions from "./store/actions/auth";

// import HistoryListener from "./tracking";

import Navbar from "./layout/Navbar/Navbar";
import Footer from "./layout/Footer/Footer";
import ScrollToTop from "./layout/Navbar/ScrollToTop";

import Home from "./pages/Home/Home";

import Sponsors from "./pages/About/Sponsors/Sponsors";
import Athletes from "./pages/About/Athletes/Athletes";
import Athlete from "./pages/About/Athletes/Athlete/Athlete";
import Story from "./pages/About/Story/Story";
import Schedule from "./pages/About/Schedule/Schedule";

import Overview from "./pages/Training/Overview/Overview";
import Circuits from "./pages/Training/Circuits/Circuits";
import RunningHealth from "./pages/Training/RunningHealth/RunningHealth";
import Mindset from "./pages/Training/Mindset/Mindset";
import Nutrition from "./pages/Training/Nutrition/Nutrition";
import WorkoutBuilder from "./pages/Training/WorkoutBuilder/WorkoutBuilder";

import News from "./pages/News/News";
import Auth from "./pages/Auth/Auth";
import Logout from "./pages/Auth/Logout/Logout";
import Shop from "./pages/Shop/Shop";

// import AFH from "./pages/AFH/AFH";

import DMVMeet from "./pages/Events/DMVMeet/DMVMeet";

// import CountDown from "./pages/CountDown/CountDown";

import "./App.css";

class App extends Component {
  componentDidMount() {
    // initGA();
    // ReactGA.initialize("G-R9HDP880XQ");
    firebase.auth().onAuthStateChanged((user) => {
      let uid = null;
      if (user) {
        uid = user.uid;
      }
      this.props.updateAuth(uid);
    });
  }
  render() {
    return (
      <div className="App">
        {/* <BrowserRouter> */}
        <ScrollToTop>
          <Navbar />
          <main>
            {/* <Route component={HistoryListener} /> */}
            <Switch>
              <Route exact path="/" component={Home}></Route>
              <Route exact path="/home" component={Home}></Route>
              <Route path="/sponsors" component={Sponsors}></Route>
              <Route exact path="/our-team" component={Athletes}></Route>
              <Route path="/our-team/:name" component={Athlete}></Route>
              <Route path="/our-story" component={Story}></Route>
              <Route path="/schedule" component={Schedule}></Route>

              <Route path="/training/overview" component={Overview}></Route>
              <Route path="/training/strength" component={Circuits}></Route>
              <Route path="/training/health" component={RunningHealth}></Route>
              <Route path="/training/mindset" component={Mindset}></Route>
              <Route path="/training/nutrition" component={Nutrition}></Route>
              <Route
                path="/training/workout-builder"
                component={WorkoutBuilder}
              ></Route>

              {/* <Route path="/membership" component={Membership}></Route> */}
              <Route path="/news" component={News}></Route>
              <Route path="/dmv-meet" component={DMVMeet}></Route>
              <Route path="/shop" component={Shop}></Route>

              <Route exact path="/auth" component={Auth}></Route>
              <Route path="/auth/:page" component={Auth}></Route>
              <Route path="/logout" component={Logout}></Route>

              {/* <Route path="/countdown" component={CountDown}></Route> */}
              <Redirect to="/" />
            </Switch>
          </main>
          <LazyLoad once={true} offset={400}>
            <Footer />
          </LazyLoad>
        </ScrollToTop>
        {/* </BrowserRouter> */}
      </div>
    );
  }
}

// const mapStateToProps = (state) => {
//   return {
//     loading: state.loading,
//     isLoggedIn: state.token !== null,
//   };
// };

const mapDispatchToProps = (dispatch) => {
  return {
    updateAuth: (uid) => dispatch(actions.updateAuth(uid)),
  };
};

export default connect(null, mapDispatchToProps)(App);
